import type { HelpFile } from '../../types/help'
import { SkipToContentLinkTestIds } from '../../../testids/SkipToContentLinkTestIds'

export const skipToContentLinkHelp: HelpFile = {
  docPage: '/docs/accessibility/skip-link',
  texts: {
    [SkipToContentLinkTestIds.skipToContentLink]: null,
  },
}
